import { render, staticRenderFns } from "./RankedSummary.vue?vue&type=template&id=707ffd1d&"
import script from "./RankedSummary.vue?vue&type=script&lang=js&"
export * from "./RankedSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports